// extracted by mini-css-extract-plugin
module.exports = {"wrap":"Number_wrap__p2RwD","input":"Number_input__RPxAx","label":"Number_label__OWAbc"};